const e = {
  cbsa: {
    visible: !1
  },
  county: {
    visible: !0,
    range: [3, 7]
  },
  zipcode: {
    visible: !0,
    range: [7, 10.8]
  },
  cbg: {
    visible: !0,
    range: [10.8, 12]
  }
};
export {
  e as DEFAULT_ZOOM_DETAILS
};
//# sourceMappingURL=index.es477.js.map
